
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0a294a","d":"M14.498 6.787v6.468c0 1.976-.705 3.662-2.114 5.058-1.41 1.398-3.117 2.096-5.122 2.096-2.007 0-3.719-.698-5.136-2.096C.708 16.917 0 15.231 0 13.255v-6.37l.025-.098c.082-1.895.824-3.5 2.225-4.814C3.651.658 5.322 0 7.262 0c1.94 0 3.61.658 5.01 1.973zm-3.58-3.26c-1.013-.996-2.231-1.494-3.656-1.494-1.426 0-2.65.498-3.669 1.494-1.02.997-1.529 2.198-1.529 3.603 0 1.404.51 2.608 1.53 3.613 1.019 1.005 2.242 1.507 3.668 1.507 1.425 0 2.643-.502 3.655-1.507 1.011-1.005 1.517-2.209 1.517-3.613zM4.152 14.902a5.647 5.647 0 003.109.908 5.588 5.588 0 003.095-.908 5.522 5.522 0 002.077-2.382v-.392c-1.426 1.44-3.15 2.16-5.172 2.16-2.04 0-3.773-.72-5.198-2.16v.392zm0 2.431a4.995 4.995 0 003.109 1.042c1.16 0 2.196-.347 3.108-1.042a5.047 5.047 0 001.84-2.657c-1.343 1.437-2.992 2.156-4.948 2.156-1.957 0-3.606-.72-4.95-2.156z","opacity":".75"}})])
          )
        }
      }
    